import React from 'react';
import { Typography, Paper } from '@mui/material';
import { AGENT_VIEW_RENDERERS } from '../navigation/portalPageRegistry';

function AgentDashboard({
    selectedView,
    agentViewMode = false,
    escalationsAvailability = null,
    escalationsAvailabilityLoaded = false,
    onEscalationsAvailabilityChange
}) {
    const renderer = AGENT_VIEW_RENDERERS[selectedView];
    if (!renderer) {
        return (
            <Paper sx={{ p: 3 }}>
                <Typography variant="h4" gutterBottom>
                    Page Not Found
                </Typography>
            </Paper>
        );
    }

    return renderer({
        agentViewMode,
        escalationsAvailability,
        escalationsAvailabilityLoaded,
        onEscalationsAvailabilityChange
    });
}

export default AgentDashboard;
